export default "__VITE_ASSET__BUvzyETu__"